import React, { useState } from 'react'
import { Formik } from 'formik'
import { useDispatch } from 'react-redux'
import { _, withCapture } from 'utils'
import { PosterType } from 'generated/graphql'
import FullPageLoading from 'components/FullPageLoading'
import { showNotification } from '../../notifications'
import { showErrorNotification } from '../../notifications/notificationsSlice'
import { FormContent, PosterValidation } from './CreatePoster'
import { getChangedValues } from '../../forms/utils'
import { updatePoster } from '../graphql/mutation'

interface Props {
    close?: () => void
    callGetPosters?: () => void
    poster?: PosterType
    enableChat: boolean
}

const UpdatePoster = ({
    close, callGetPosters, poster, enableChat
}: Props) => {
    const dispatch = useDispatch()
    const initialValues = { ...poster, authorEmail: poster?.author?.email }
    const [isUpLoading, setIsUploading] = useState(false)

    const onSubmit = withCapture(async (values) => {
        setIsUploading(true)
        const submitValues = getChangedValues(initialValues, values)
        const response = await updatePoster(poster.id, submitValues)
        setIsUploading(false)
        if (!response.data || response.errors.length) {
            dispatch(showErrorNotification(response.errors))
            return
        }

        dispatch(showNotification({
            type: 'success',
            body: _('form.notification.create_success'),
        }))
        callGetPosters()
        close()
    })

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={PosterValidation}
        >
            <>
                <FormContent close={close} enableChat={enableChat} />
                {isUpLoading && <FullPageLoading isAbsolute fullWidth />}
            </>
        </Formik>
    )
}

export default UpdatePoster
